/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum SelectionStrategyType {
    DIVERSITY = 'DIVERSITY',
    WEIGHTS = 'WEIGHTS',
    THRESHOLD = 'THRESHOLD',
    BALANCE = 'BALANCE',
    SIMILARITY = 'SIMILARITY'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const SelectionStrategyTypeValidatorShape = [
    'DIVERSITY',
    'WEIGHTS',
    'THRESHOLD',
    'BALANCE',
    'SIMILARITY'
];
export const SelectionStrategyTypeValidator = yup.mixed().oneOf(SelectionStrategyTypeValidatorShape);
export const SelectionStrategyTypeStringifyShapeProperties = {};
export const SelectionStrategyTypeStringifyShape: StringSchema = {
    title: 'SelectionStrategyType Stringifier',
    type: 'string'
};
export const SelectionStrategyTypeStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(SelectionStrategyTypeStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function SelectionStrategyTypeFromJSON(json: any): SelectionStrategyType {
    return SelectionStrategyTypeFromJSONTyped(json, false);
}
export function SelectionStrategyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectionStrategyType {
    return json as SelectionStrategyType;
}
export function SelectionStrategyTypeToJSON(value?: SelectionStrategyType | null): any {
    return value as any;
}
